import { createContext, useState, useContext, Children } from 'react';
import { NETWORK_ERROR_CODE } from 'utils/constants/system';
import InternalErrorPage from 'pages/500';

export const ErrorContext = createContext<{ spreadError: (message: unknown) => void }>({ spreadError: () => {} });

export const ErrorProvider = ({ error, children }: { error: unknown; children: React.ReactNode }) => {
  const [localError, setLocalError] = useState<string | false>(false);

  const spreadError = (message: unknown) => {
    if (message !== NETWORK_ERROR_CODE) {
      // para errores que React no detecta
      console.error('React Error in Client  => ', String(message));
      setLocalError(String(message));
    }
  };

  const firstChild = Children.toArray(children)[0] as any;
  const firstChildDisplayName = firstChild?.type?.displayName as string | undefined;

  if (error === false && localError === false && firstChildDisplayName !== 'ErrorPage') {
    try {
      return <ErrorContext.Provider value={{ spreadError }}>{children}</ErrorContext.Provider>;
    } catch (e) {
      return <InternalErrorPage />;
    }
  }
  return <InternalErrorPage />;
};

export function useErrorContext() {
  const context = useContext(ErrorContext);
  if (context === undefined) {
    throw new Error('useErrorContext must be used within an ErrorProvider');
  }
  return context;
}
